/**
 * Serializes the initial silent-refresh-on-load across same-origin tabs
 * using the Web Locks API, so two tabs opened at once don't both race the
 * same refresh-token cookie. Falls back to running `fn` unguarded when the
 * API is unsupported -- the backend's rotation grace-period (see
 * AuthTokenService::refresh()) absorbs that race safely too, just at the
 * cost of one extra network round trip on the losing tab.
 */
// Minimal structural type for the Web Locks API -- avoids depending on the
// `LockManager`/`Lock` DOM lib types not being present in every TS config.
interface MinimalLockManager {
  request<T>(name: string, callback: () => Promise<T>): Promise<T>;
}

export async function withRefreshLock<T>(fn: () => Promise<T>): Promise<T> {
  const locks: MinimalLockManager | undefined =
    typeof navigator !== "undefined"
      ? (navigator as Navigator & { locks?: MinimalLockManager }).locks
      : undefined;
  if (!locks) return fn();

  return locks.request("arteria-auth-refresh", fn);
}
